<template>
  <td :colspan="headers.length" class="pa-0 breakdown-bg">
    <div class="pa-6">
      <div class="text-subtitle-2 font-weight-medium mb-4 breakdown-title">
        {{ $t('billing.breakdown.title') }}
      </div>

      <invoice-breakdown-table :breakdown="item.breakdown" />
    </div>
  </td>
</template>

<script>
import InvoiceBreakdownTable from "./InvoiceBreakdownTable.vue";

export default {
  name: "InvoiceExpandedRow",
  components: {
    InvoiceBreakdownTable,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.breakdown-bg {
  background: #111111 !important;
}

.breakdown-title {
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.7rem !important;
}
</style>
